import React from 'react';

import { useExchangeRate } from '$contexts/exchange-rate';
import BaseSelect from '$partials/fields/select.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').CurrencySelector}
 */
const CurrencySelector = ({
    className
}) => {
    const {
        currency,
        setCurrency
    } = useExchangeRate();

    const currencyOptions = [
        { label: 'GBP', value: 'GBP' },
        { label: 'EUR', value: 'EUR' },
        { label: 'USD', value: 'USD' },
        { label: 'ILS', value: 'ILS' },
    ];

    return (
        <BaseSelect
            displayValue={currencyOptions.find((opt) => opt.value === currency)?.label}
            name='currency'
            onChange={(currency) => setCurrency(currency)}
            options={currencyOptions}
            triggerClassName={className}
            value={currency} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default CurrencySelector;
